import { render, staticRenderFns } from "./index.html?vue&type=template&id=1cdd742f&scoped=true&"
import script from "./campaign.js?vue&type=script&lang=js&"
export * from "./campaign.js?vue&type=script&lang=js&"
import style0 from "./campaign.scss?vue&type=style&index=0&id=1cdd742f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd742f",
  null
  
)

export default component.exports